import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Building2, Settings, LogOut, Home, HelpCircle, Shield } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import AppSidebar, { SidebarItem } from '../shell/AppSidebar';
import { getInitialSidebarCollapsed } from '../../utils/initialSidebarCollapsed';
import { openAppHelp } from '../../utils/appHelp';

export default function AdminLayout() {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isDashboard = location.pathname === '/admin' || location.pathname === '/admin/';
  const isLicenses = location.pathname.startsWith('/admin/licenses');
  const isPlatformUsers = location.pathname.startsWith('/admin/users');
  const isSettings = location.pathname === '/admin/settings';
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => getInitialSidebarCollapsed());

  return (
    <div className="flex h-screen overflow-hidden bg-[var(--app-shell-bg)] font-sans text-[var(--ink)]">
      <AppSidebar
        collapsed={sidebarCollapsed}
        onToggleCollapsed={() => setSidebarCollapsed((v) => !v)}
        footer={
          <>
            <SidebarItem icon={HelpCircle} label="Help" onClick={openAppHelp} collapsed={sidebarCollapsed} />
            <SidebarItem
              icon={Settings}
              label="Settings"
              active={isSettings}
              onClick={() => navigate('/admin/settings')}
              collapsed={sidebarCollapsed}
            />
            <SidebarItem
              icon={LogOut}
              label="Sign out"
              variant="danger"
              onClick={logout}
              collapsed={sidebarCollapsed}
            />
          </>
        }
      >
        <SidebarItem
          icon={Home}
          label="Dashboard"
          active={isDashboard}
          onClick={() => navigate('/admin')}
          collapsed={sidebarCollapsed}
        />
        <SidebarItem
          icon={Building2}
          label="Client Licenses"
          active={isLicenses}
          onClick={() => navigate('/admin/licenses')}
          collapsed={sidebarCollapsed}
        />
        <SidebarItem
          icon={Shield}
          label="Platform Users"
          active={isPlatformUsers}
          onClick={() => navigate('/admin/users')}
          collapsed={sidebarCollapsed}
        />
      </AppSidebar>
      <Outlet />
    </div>
  );
}
